import type { SchemaInput, SchemaRecord } from './schema-input.js';

type RuntimeFunction = (...args: never[]) => void;

export function isString<Value>(value: Value): value is Value & string {
  return typeof value === 'string';
}

export function isNumber<Value>(value: Value): value is Value & number {
  return typeof value === 'number';
}

export function isBoolean<Value>(value: Value): value is Value & boolean {
  return typeof value === 'boolean';
}

export function isObject<Value>(value: Value): value is Value & (object | null) {
  return typeof value === 'object';
}

export function isSchemaRecord(value: SchemaInput): value is SchemaRecord {
  return value !== null && isObject(value) && !Array.isArray(value);
}

export function isFunction<Value>(value: Value): value is Value & RuntimeFunction {
  return typeof value === 'function';
}

export function isUndefined<Value>(value: Value): value is Value & undefined {
  return typeof value === 'undefined';
}

export function ownValue<RecordType extends object>(record: RecordType, key: PropertyKey): RecordType[keyof RecordType] | undefined {
  if (!Object.hasOwn(record, key)) return undefined;
  // SAFETY: Object.hasOwn proves that key selects an own property of record.
  return record[key as keyof RecordType];
}
